import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  faUsers,
  faIdBadge,
  faExclamationTriangle,
  faUserHardHat,
  faTasks,
  faExchange,
} from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function TypeSelectButton({ id, children, icon }) {
  const dispatch = useDispatch();
  const { tab, ready } = useSelector(store => store.batch);
  const disabled = !ready;

  const active = tab === id;

  return (
    <button
      type="button"
      className={`btn ${active ? 'btn-dark' : 'btn-white'} shadow-sm border-light text-right`}
      disabled={disabled}
      onClick={() => dispatch({ type: 'CHANGE_BATCH_TAB', tab: id })}
    >
      {children}
      <FontAwesomeIcon icon={icon} fixedWidth size="lg" className="ms-2" />
    </button>
  );
}

function TypeSelectTile() {
  const dispatch = useDispatch();
  const { previewing, ready } = useSelector(store => store.batch);
  const {
    statePermissions: statePermissionsFeature,
    agentUpload: agentUploadFeature,
    leadReassignment: leadReassignmentFeature,
  } = useSelector(store => store.theme.features);

  const disabled = !ready;

  return (
    <div className="col-md-4 text-center p-4">
      <div>
        <div
          className={[
            'border border-dark border-lg rounded-circle d-inline-flex text-dark',
            'd-flex justify-content-center align-items-center font-weight-bold font-large',
          ].join(' ')}
          style={{ height: '3rem', width: '3rem' }}
        >
          1
        </div>
      </div>

      <div className="my-3">
        <div className="font-weight-bold">
          Select your upload type to get started.
        </div>
      </div>

      <div>
        <div className="btn-group-vertical">
          <button
            type="button"
            className={`btn ${previewing ? 'btn-dark' : 'btn-danger'} mb-3 text-right`}
            onClick={() => dispatch({ type: 'TOGGLE_PREVIEW_MODE' })}
            disabled={disabled}
          >
            Preview Mode:
            {previewing ? ' ON' : ' OFF'}
            <FontAwesomeIcon
              icon={previewing ? faUserHardHat : faExclamationTriangle}
              fixedWidth
              size="lg"
              className="ms-2"
            />
          </button>

          {agentUploadFeature && (
            <TypeSelectButton id="agent" icon={faUsers}>Agents Info</TypeSelectButton>
          )}
          {statePermissionsFeature && (
            <TypeSelectButton id="license" icon={faIdBadge}>State License Info</TypeSelectButton>
          )}
          <TypeSelectButton id="leads" icon={faTasks}>Leads Create</TypeSelectButton>
          {leadReassignmentFeature && (
            <TypeSelectButton id="leads_reassignment" icon={faExchange}>Leads Reassignment</TypeSelectButton>
          )}
        </div>
      </div>
    </div>
  );
}

export default TypeSelectTile;
